import { CustomCellRendererProps } from 'ag-grid-react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { get } from 'lodash-es';
import { Stack, Typography } from '@mui/material';
import { colors } from '../../../theme/colors';

export interface IFieldNameRendererProps extends CustomCellRendererProps {
  namePath: string;
  descriptionPath: string;
}

export function FieldNameRenderer(props: IFieldNameRendererProps) {
  const { data, namePath, descriptionPath, value } = props;
  const name = get(data, namePath);
  const description = get(data, descriptionPath);
  if (!name) {
    return <>{value}</>;
  }
  return (
    <Stack direction='row' alignItems='center' gap={2} height='100%'>
      <Typography variant='body2' noWrap component='span'>
        {name}
      </Typography>
      <DescriptionIcon description={description} />
    </Stack>
  );
}

export function DescriptionIcon(props: { description: string | null }) {
  const { description } = props;
  if (!description) {
    return null;
  }
  return <InfoOutlinedIcon fontSize='small' htmlColor={colors.neutral[60]} titleAccess={description} />;
}
